import { Controller } from "@hotwired/stimulus"

// Scrolls a search box's placeholder up through what it can find, one line at
// a time, ending on a copy of the first so it loops without a jump. It holds
// still while the box is in use, and for people who prefer less motion.
export default class extends Controller {
  static targets = ["list"]
  static values = { label: String, interval: { type: Number, default: 4000 } }

  connect() {
    this.input = this.element.querySelector("input")
    this.index = 0
    if (this.labelValue) this.input.setAttribute("aria-label", this.labelValue)
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  next() {
    if (document.activeElement === this.input || this.input.value) return

    this.index++
    this.move()
    if (this.index === this.listTarget.children.length - 1) {
      this.listTarget.addEventListener("transitionend", () => this.reset(), { once: true })
    }
  }

  reset() {
    this.index = 0
    this.listTarget.style.transition = "none"
    this.move()
    this.listTarget.offsetHeight
    this.listTarget.style.transition = ""
  }

  move() {
    this.listTarget.style.transform = `translateY(-${this.index * 100 / this.listTarget.children.length}%)`
  }
}
